// extracted by css-extract-rspack-plugin
export default {"cls1":"TypeWriter-cls1_-Sy","cls2":"TypeWriter-cls2_Avo TypeWriter-cls1_-Sy"};